var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isReady
    ? _c("div", { attrs: { "data-page": "regions-service-areas" } }, [
        _c(
          "div",
          { staticClass: "page-header with-breadcrumbs typography" },
          [
            _c("h1", [_vm._v(_vm._s(_vm.t("app-service-areas")))]),
            _vm._v(" "),
            _c("breadcrumbs", { attrs: { trail: _vm.trail } }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "areas" },
          [
            _c("available-service-areas", {
              ref: "available",
              attrs: { id: "available", route: "app/affiliates/zip" },
              on: {
                addServiceArea: _vm.onAdd,
                addAllServiceAreas: _vm.onAddAll,
              },
            }),
            _vm._v(" "),
            _c("selected-service-areas", {
              ref: "selected",
              attrs: {
                id: "selected",
                route: `app/affiliates/${this.$route.params.id}/zip`,
              },
              on: {
                removeServiceArea: _vm.onRemove,
                removeAllServiceAreas: _vm.onRemoveAll,
              },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }